import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchReturnOrderDetails } from "../../../Features/orderDetailsSlice";
import { useSelector } from "react-redux";
import Loading from "../../../Components/Loading/Loading";
import ArrowLeft from "../../../Assets/Arrow left.svg";
import OrderStats from "./Component/OrderStats";
import ReturnRequestDetails from "./Component/ReturnRequestDetails";
import ProductDetails from "./Component/ProductDetails";

const ReturnOrderDetails = () => {
  const { orderId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const { orderDetails, loading } = useSelector(
    (state) => state.orderDetails.returnOrderDetails
  );

  useEffect(() => {
    orderId && dispatch(fetchReturnOrderDetails(orderId));
  }, [orderId]);

  return (
    <>
      {loading === "loading" ? (
        <div className="flex justify-center items-center h-dvh">
          <Loading size={40} bgColor="#FFF"/>
        </div>
      ) : (
        <div className="w-full overflow-y-scroll pb-16 outline-none">
          <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
            <div className="w-fit flex items-center">
              <Link
                to={`${location.pathname.split("/").slice(0, -2).join("/")}`}
                className="img p-[10px] flex items-center justify-center"
              >
                <img
                  className="w-6 h-6 text-[#666666]"
                  src={ArrowLeft}
                  alt=""
                />
              </Link>

              <h1 className="p-[6px] text-[#121212] font-bold leading-8 text-[24px]">
                Order Details &#40;#{orderDetails?.orderId?.slice(-6)}&#41;
              </h1>
            </div>
          </div>

          <OrderStats />

          <ReturnRequestDetails />

          <div className="flex gap-2 mx-5 mt-3">
            <div className="w-3/5 h-fit flex flex-col gap-2">
              <ProductDetails orderDetails={orderDetails} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReturnOrderDetails;
